(()=>{
  'use strict';
  const footer=document.querySelector('#site-footer.erp-footer');
  const dialog=document.getElementById('erp-footer-whatsapp');
  if(!footer||!dialog)return;
  const floating=footer.querySelector('.ef-floating-whatsapp');
  const restore=footer.querySelector('[data-ef-floating-restore]');
  const hide=dialog.querySelector('[data-ef-floating-hide]');
  const close=dialog.querySelector('[data-ef-close]');
  let opener=null;
  let returnToContent=false;
  function focus(element){
    if(!element||!element.isConnected||element.hidden)return;
    try{element.focus({preventScroll:true});}catch(error){element.focus();}
  }
  function focusContent(){
    const content=document.querySelector('main,[role="main"]');
    if(!content)return;
    const temporary=!content.hasAttribute('tabindex');
    if(temporary){
      content.setAttribute('tabindex','-1');
      content.addEventListener('blur',()=>content.removeAttribute('tabindex'),{once:true});
    }
    focus(content);
  }
  footer.querySelectorAll('[data-site-whatsapp]').forEach(button=>button.addEventListener('click',()=>{
    document.querySelectorAll('dialog[open]').forEach(other=>other.close());
    opener=button;
    returnToContent=false;
    dialog.showModal();
  }));
  if(close)close.addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',event=>{
    if(event.target!==dialog)return;
    const bounds=dialog.getBoundingClientRect();
    if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)dialog.close();
  });
  dialog.addEventListener('close',()=>{
    if(dialog.open)return;
    if(returnToContent)focusContent();
    else focus(opener);
    returnToContent=false;
  });
  if(floating&&restore&&hide){
    hide.addEventListener('click',()=>{
      floating.hidden=true;
      restore.hidden=false;
      returnToContent=opener===floating;
      dialog.close();
    });
    restore.addEventListener('click',()=>{
      floating.hidden=false;
      restore.hidden=true;
      focus(floating);
    });
  }
  function syncOverlay(){
    document.documentElement.classList.toggle('erp-wa-overlay-open',Boolean(document.querySelector('dialog[open]')));
  }
  const overlayObserver=new MutationObserver(syncOverlay);
  overlayObserver.observe(document.body,{attributes:true,attributeFilter:['open'],subtree:true});
  syncOverlay();
  function syncFormFocus(){
    const active=document.activeElement;
    const editing=active instanceof Element&&Boolean(active.closest('input:not([type="button"]):not([type="submit"]):not([type="hidden"]),textarea,select,[contenteditable="true"]'));
    document.documentElement.classList.toggle('erp-wa-form-focus',editing);
  }
  document.addEventListener('focusin',syncFormFocus);
  document.addEventListener('focusout',()=>queueMicrotask(syncFormFocus));
})();
